import HTTP from './http-interceptor';
import { AUTH } from '../constants';

const AreasService = {
    
    getAreas: (user) => {
        return HTTP.get(`${AUTH.PLAYER_AREAS}${user}`);
    },
}

export default AreasService;